// components
import { Typography } from '@centria-ui/components/atoms/typography'

// prime components
import { InputSwitch as PrInputSwitch } from 'primereact/inputswitch'

// styles
import classes from './styles.module.scss'

// types
import type { InputSwitchProps as PrInputSwitchProps } from 'primereact/inputswitch'
import type { FC } from 'react'

export interface SwitchProps extends PrInputSwitchProps {
  label?: string
  rowReverse?: boolean
}

export const Switch: FC<SwitchProps> = ({
  label,
  className = '',
  rowReverse = false,
  ...props
}) => {
  return (
    <div
      className={`${rowReverse && 'flex-row-reverse'} ${
        classes.switchContainer
      }`}>
      <PrInputSwitch {...props} className={`${className} ${classes.switch}`} />
      {label && (
        <Typography htmlFor={props.inputId} Tag='label' fontSize='small'>
          {label}
        </Typography>
      )}
    </div>
  )
}
